import { render, staticRenderFns } from "./DocumentPOSTotalGroupsPrint.vue?vue&type=template&id=563e9d3e&scoped=true"
import script from "./DocumentPOSTotalGroupsPrint.vue?vue&type=script&lang=js"
export * from "./DocumentPOSTotalGroupsPrint.vue?vue&type=script&lang=js"
import style0 from "./DocumentPOSTotalGroupsPrint.vue?vue&type=style&index=0&id=563e9d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563e9d3e",
  null
  
)

export default component.exports